import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useTranslation } from "@coworker/locales";
import CustomPeriodCss from "./CustomPeriod.module.css";
import { SelectOption, SelectOptionPeriod } from "../../types/filter";
import { DatePicker } from "../../../components/DatePicker/DatePicker";

dayjs.extend(isSameOrBefore);

interface CustomPeriodProps {
  onChange: (option: SelectOption) => void;
  selected: SelectOptionPeriod;
}

export const CustomPeriod = ({ onChange, selected }: CustomPeriodProps) => {
  const today = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  const { startDate, endDate } = selected;

  const { t } = useTranslation();

  const handleStartDateChange = (value: string) => {
    const newStart = dayjs(value);
    const currentEnd = dayjs(endDate);

    if (!endDate || newStart.isBefore(currentEnd)) {
      onChange({ ...selected, startDate: value });
    }
  };

  const handleEndDateChange = (value: string) => {
    const newEnd = dayjs(value);
    const currentStart = dayjs(startDate);

    if (
      (!startDate || newEnd.isAfter(currentStart)) &&
      newEnd.isSameOrBefore(dayjs())
    ) {
      onChange({ ...selected, endDate: value });
    }
  };

  return (
    <div className={CustomPeriodCss["custom-period"]}>
      <DatePicker
        label={t("startDateString")}
        value={startDate}
        onChange={(value) => handleStartDateChange(value)}
        max={
          dayjs(endDate).isValid()
            ? dayjs(endDate).subtract(1, "day").format("YYYY-MM-DD")
            : yesterday
        }
      />
      <DatePicker
        label={t("endDateString")}
        value={endDate}
        onChange={(value) => handleEndDateChange(value)}
        min={
          dayjs(startDate).isValid()
            ? dayjs(startDate).add(1, "day").format("YYYY-MM-DD")
            : ""
        }
        max={today}
      />
    </div>
  );
};
